import { gql } from "@apollo/client";

const GET_FECHA_ETAPA_RESPONSABLE = gql`
query etapaResponable ( $idGestionReclamo: Int!) {
    etapaResponable( idGestionReclamo: $idGestionReclamo ){
        fechaRealizacion
        idHistorialReclamo
    }
}
`;
export default GET_FECHA_ETAPA_RESPONSABLE;